import { render } from "./TaskForm.vue?vue&type=template&id=fa1a902e&scoped=true"
import script from "./TaskForm.vue?vue&type=script&lang=js"
export * from "./TaskForm.vue?vue&type=script&lang=js"

import "./TaskForm.vue?vue&type=style&index=0&id=fa1a902e&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa1a902e"]])

export default __exports__